(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gowish-code-snippet"] && !Shopify.designMode) return;
  try {
    const gowishButton = document.getElementById('gowishBlueButton');
  if (gowishButton) {
    gowishButton.addEventListener('click', function () {
      Shopify.analytics.publish('product_added_to_onskeskyen');
    });
  }
  } catch(e) { console.error(e); }
})();

})();
